export const COUNTRIES_ICON_PATH = '/icons/countries/';

export enum IMAGES {
  ErrorFallbackGeneral = '/images/error-fallback-general.svg',
  ErrorFallbackPage = '/images/file-not-found-icon.svg',
  AutofillAvailable = '/images/autofill_available.svg',
  AutofilledAnswer = '/images/autofilled_answer.svg',
  ExportFile = '/images/export_file.svg',
  NetworkError = '/images/illustration_500.png',
  StatusQuoExport = '/images/status-quo-export.png',
  StatusQuoExportWithTitle = '/images/status-quo-export-with-title.png',
  StatusQuoExportWithTitleAndDesc = '/images/status-quo-export-with-title-desc.png',
  CollapseIcon = '/icons/collapse.svg',
  MoveToIcon = '/icons/move_to.svg',
}

export enum TechnologyIcons {
  energySource = '/icons/technology/route/energy_source.svg',
  energySourceV2 = '/icons/technology/route/energy_source_v2.svg',
  generator = '/icons/technology/route/generator.svg',
  storage = '/icons/technology/route/storage.svg',
  distribution = '/icons/technology/route/distribution.svg',
  heating = '/icons/technology/heating.svg',
  heatingV2 = '/icons/technology/heatingV2.svg',
  cooling = '/icons/technology/cooling.svg',
  coolingV2 = '/icons/technology/coolingV2.svg',
  lighting = '/icons/technology/lighting.svg',
  ventilation = '/icons/technology/ventilation.svg',
  warm_water = '/icons/technology/warm_water.svg',
  electricity = '/icons/technology/electricity.svg',
  solar = '/icons/technology/solar.svg',
  solarGray = '/icons/technology/solar_gray.svg',
  custom = '/icons/technology/custom.svg',
}

export enum CommonIcons {
  excel_export = '/icons/file-xls-outline.svg',
  excel_export_dark = '/icons/file-xls-outline_dark.svg',
}
